import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FullScreenTakeoverProps {
  show: boolean;
  onHide: () => void;
  noCloseButton?: boolean;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export function FullScreenTakeover({
  show,
  onHide,
  noCloseButton = false,
  children,
  className,
  title,
}: FullScreenTakeoverProps) {
  return (
    <Dialog open={show} onOpenChange={onHide}>
      <DialogContent
        className={cn(
          'max-w-[85vw] w-[85vw] h-[85vh] max-h-[85vh] p-0 flex flex-col translate-x-[-50%] translate-y-[-50%]',
          // Direct children only. `[&_button.absolute]` matched *any*
          // descendant, so a takeover's own content could not use an
          // absolutely-positioned button — it silently vanished. Radix's
          // close button is a direct child of DialogContent, so scoping to
          // `>` still hides the thing this is here to hide.
          (noCloseButton || title) && '[&>button]:hidden [&>button.absolute]:hidden',
          className
        )}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        {title && (
          <DialogHeader className="px-6 py-4 border-b border-border flex-shrink-0">
            <div className="flex items-center justify-between">
              <DialogTitle>{title}</DialogTitle>
              <Button
                variant="ghost"
                size="icon"
                onClick={onHide}
                className="h-6 w-6"
                title="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </DialogHeader>
        )}
        <div className="flex-1 overflow-hidden flex flex-col min-h-0 h-full">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}

